import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, X } from "lucide-react";
import { useT } from "../lib/i18n";

export default function PaymentCancel() {
  const { lang } = useT();
  return (
    <main className="min-h-screen bg-[#F5F3F0] grain flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-xl w-full border border-[#0A0A0A] p-8 md:p-12 bg-[#EAE7E2]"
      >
        <div className="w-14 h-14 rounded-full border border-[#0A0A0A] flex items-center justify-center mb-6">
          <X size={22} strokeWidth={1.5} />
        </div>
        <div className="chip text-[#4A4A4A]">— {lang === "en" ? "Payment cancelled" : "Betaling geannuleerd"}</div>
        <h1 className="font-display uppercase text-4xl md:text-6xl mt-2 leading-[0.92] text-[#0A0A0A]">
          {lang === "en" ? "No worries." : "Geen zorgen."}
        </h1>
        <p className="mt-4 text-[#0A0A0A]">
          {lang === "en"
            ? "You closed the checkout before finishing. Nothing has been charged — you can pick up where you left off any time."
            : "Je hebt de checkout gesloten voordat het af was. Er is niets afgeschreven — je kunt op elk moment verdergaan."}
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/join" className="btn" data-testid="cancel-try-again">
            {lang === "en" ? "Try again" : "Probeer opnieuw"} <ArrowUpRight size={14}/>
          </Link>
          <Link to="/" className="btn-ghost" data-testid="cancel-home">
            {lang === "en" ? "Back home" : "Terug naar home"}
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
